(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name crewVoyageReport.controller:CrewVoyageReportCtrl
   *
   * @description
   *
   */
  angular
    .module('crewVoyageReport')
    	.directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
    .controller('CrewVoyageReportCtrl', CrewVoyageReportCtrl);

  function CrewVoyageReportCtrl($sce,EventManagerService, MessageService, RenewalsService, PopupManager, applicationConstants,
          CommonMasterData, CommonLogicService,CrewVoyageReportService,RemoteService) {
    var vm = this;
    vm.ctrlName = 'CrewVoyageReportCtrl';

    vm.model = {
            searchOnGoing: false,
            searchPanelToggle: true,
            initialSearchDone: false,
            searchCriteria: {
                fromDate: null,
                toDate: null,
                crewId: null,
                crewType: null,
                crewName: null,
                department: null
            },
            masterList: {
                crewTypes: [],
                crewNames : [],
                departments: [],
                fromDateAfterToDate : false,
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false
            },
            reportServerBaseUrl : null,
            reportDataUrl : ""

    };

    vm.clickOnSearch = function (){
        vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
        vm.model.initialSearchDone = false;
    };

    vm.changeEditorField = function(searchParams,flag){
    	switch (flag) {
		case "CREW_TYPE":
			setCrewName();
			break;
		case "crewName":
			vm.model.searchCriteria.crewId = searchParams.crewName.crewId;
			break;
		case "fromDate" :
			var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
        	if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
        		searchParams.toDate = tempFromDate;
        	}
			validateDateFields();
			break;
		case "toDate" :
			validateDateFields();
			break;
        case "crewId":
          setDefaultCrewDetails();
          break;
		default:
			break;
		}
    };

    function validateDateFields(){
    	setDateValidationFlags();
		if(!!vm.model.searchCriteria.fromDate && !!vm.model.searchCriteria.toDate
				&& !vm.model.masterList.fromDateFormatInvalid  && !vm.model.masterList.toDateFormatInvalid){
			if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
			}else{
				vm.model.masterList.fromDateAfterToDate = false;
			}
		}
    };

    function setDefaultCrewDetails() {
      if(!!vm.model.searchCriteria.crewType){
        vm.model.searchCriteria.crewType = null;
      }
      vm.model.searchCriteria.crewName='';
    }

    function setDateValidationFlags(){
		//if from date invalid
		if(isDateFormatInvalid(vm.model.searchCriteria.fromDate)){
			vm.model.masterList.fromDateFormatInvalid = true;
			vm.model.masterList.fromDateAfterToDate = false;
		}else{
			vm.model.masterList.fromDateFormatInvalid = false;
		}

		//if to date invalid
		if(isDateFormatInvalid(vm.model.searchCriteria.toDate)){
			vm.model.masterList.toDateFormatInvalid = true;
			vm.model.masterList.fromDateAfterToDate = false;
		}else{
			vm.model.masterList.toDateFormatInvalid = false;
		}
	};

	function isDateFormatInvalid(date){
		if(!!date && !moment(date, "DD/MM/YYYY").isValid()){
			return true;
		}
		return false;
	};

	// check from date and to date
	function istoDateBeforeFromDate() {
		return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
				.isBefore(
						moment(vm.model.searchCriteria.fromDate,
								"DD/MM/YYYY"));
	}
	;

    vm.searchByOptions = function(searchParams){
    	if(isValidSearchParams(searchParams)){
    		vm.model.searchPanelToggle = false;

        var data = {
          fromDate : searchParams.fromDate,
          toDate : searchParams.toDate,
          crewType : searchParams.crewType === null ? "" : searchParams.crewType.crewTypeCode,
          crewId : !searchParams.crewId ? !searchParams.crewName ? "" : searchParams.crewName.crewId : searchParams.crewId,
          department : searchParams.department !== null && searchParams.department.length > 0 ?
            searchParams.department.map(function(dep) { return dep.code; }).join(",")
            :
            "",
        };

        var url = CommonLogicService.getReportUrl('voyage_report.rptdesign',data);
        vm.model.reportDataUrl = $sce.trustAsResourceUrl(url);

      }
    };

  //validate search Params
	function isValidSearchParams(params) {
		setDateValidationFlags();
		// if date invalid
		if(vm.model.masterList.fromDateFormatInvalid  || vm.model.masterList.toDateFormatInvalid){
			vm.model.masterList.fromDateAfterToDate = false;
			return false;
		}else if (istoDateBeforeFromDate()) {
			vm.model.masterList.fromDateAfterToDate = true;
			return false;
		}
		vm.model.masterList.fromDateAfterToDate = false;
		return true;
	}

    function setCrewName(){
    	var data = vm.model.searchCriteria.crewType;

    	if(data == null || data.crewTypeCode == null){
    		return;
    	}

    	vm.model.masterList.crewNames = null;
    	vm.model.searchCriteria.crewName = null;
      CrewVoyageReportService.searchCrewNamesByCrewType(data,
       		 function(crewNames){
       			 vm.model.masterList.crewNames = crewNames;
       		 },
       		 function(error){
       			 MessageService.error(error);
       		 }
        );
    }

    CrewVoyageReportService.searchCrewTypes(
        function (crewTypes) {
            vm.model.masterList.crewTypes = crewTypes;
        },
        function (error) {
            MessageService.error(error);
        }
    );

    CrewVoyageReportService.getVoyageDepartments(
      function (departments) {
        vm.model.masterList.departments = departments.sort(function(a, b) {
          if (a.code < b.code) return -1;
          if (a.code > b.code) return 1;
          return 0;
        });
      },
      function (error) {
        MessageService.error(error);
      }
    );
  }
}());
